<template>
  <div>
    <input type="datetime-local" />
    <!--<video id="background-video" autoplay loop muted>
      <source
        src="../../assets/Depositphotos_151324262_1080p.mp4"
        type="video/mp4"
      />
    </video>-->
    <img id="background-img" src="../../assets/Ind.jpg" alt="" />
    <v-dialog v-model="showDialog" width="60vw" :key="dlgKey" persistent>
      <v-card style="z-index: 2">
        <v-toolbar color="indigo" dense>
          <v-row align="center" justify="center" dense>
            <v-col align="start" cols="4">
              <!-- Titolo -->
              <v-toolbar-title class="white--text">
                {{ this.notifica.val_int == 3 ? this.notifica.des : "Avviso" }}
              </v-toolbar-title>
            </v-col>

            <v-col cols="4">
              <v-tooltip bottom v-if="hasAllegato">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadAllegato"
                  >
                    <v-icon color="primary"> mdi-download </v-icon>
                  </v-btn>
                </template>
                <span> Scarica Allegato </span>
              </v-tooltip>

              <!-- Pulsante "Conferma" -->
              <template v-if="notifica.val_int != 2">
                <v-tooltip bottom v-if="testo_pulsante == null">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!conferma_lettura"
                      @click="confirm('X')"
                    >
                      <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                  </template>
                  <span> Conferma </span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!conferma_lettura"
                      @click="confirm('X')"
                    >
                      <span style="color: #8bc34a">{{ testo_pulsante }}</span>
                    </v-btn>
                  </template>
                  <span> Conferma </span>
                </v-tooltip>
              </template>
            </v-col>

            <v-col align="end" cols="4">
              <!-- Pulsante chiudi (solo se la notifica non è obbligatoria) -->
              <v-tooltip
                bottom
                v-if="!notifica.obbligatoria && notifica.val_int != 3"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" @click="clickChiudi">
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span> Chiudi </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-row class="mb-5 mx-5" dense justify="center" align="center">
            <!-- Logo azienda -->
            <v-col cols="2" v-if="logo_azienda !== null">
              <v-img
                contain
                class="rounded-lg"
                style="max-width: 150; max-height: 100px"
                :src="logo_azienda"
              />
            </v-col>
          </v-row>

          <v-row
            class="mb-5 mx-5"
            dense
            justify="center"
            align="center"
            v-if="notifica.val_int != 3"
          >
            <!-- Logo azienda -->
            <v-col cols="12">
              <span v-html="notifica.des"></span>
            </v-col>
          </v-row>

          <v-row dense v-if="notifica.link != null && notifica.link != ''">
            <h2
              style="
                font-weight: normal;
                text-align: center;
                color: #0000ff;
                width: 100%;
                text-decoration: underline;
                cursor: pointer;
              "
              @click="openLink"
            >
              {{ this.notifica.link }}
            </h2>
          </v-row>

          <!-- Immagine notifica -->
          <v-row
            class="pt-5 ml-5 mr-5"
            dense
            justify="center"
            align="center"
            v-if="notifica.immagine != null"
          >
            <v-img
              contain
              class="rounded-lg"
              style="max-width: 300px; max-height: 150px"
              :src="notifica.immagine"
            />
          </v-row>

          <!-- Variabili notifica -->
          <v-row dense v-if="notifica.val_int == 3" no-gutters>
            <v-col cols="12">
              <v-row dense v-for="n in numRows" :key="n">
                <v-col
                  v-for="(elemento, index) in variabili.filter(
                    (e) => e.riga == n
                  )"
                  :key="index"
                  :cols="elemento.colonne"
                >
                  <v-text-field
                    v-if="elemento.tipo < 3"
                    :label="elemento.testo"
                    :type="
                      elemento.tipo == 0
                        ? 'number'
                        : elemento.tipo == 1
                        ? 'string'
                        : 'datetime-local'
                    "
                    @change="checkValue(elemento)"
                    v-model="elemento.risposta"
                  />
                  <v-checkbox
                    v-if="elemento.tipo == 3"
                    :label="elemento.testo"
                    :true-value="1"
                    :false-value="0"
                    v-model="elemento.risposta"
                  />
                  <v-autocomplete
                    v-if="elemento.tipo == 4"
                    :label="elemento.testo"
                    v-model="elemento.risposta"
                    :items="elemento.elementi"
                    item-text="des"
                    item-value="value"
                    :style="elemento.stile"
                  >
                    <template v-slot:selection="{ item }">
                      <v-toolbar dense flat color="rgba(0,0,0,0)">
                        <v-spacer></v-spacer>
                        <span :style="elemento.stile">
                          {{ item.des }}
                        </span>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-toolbar dense flat color="rgba(0,0,0,0)">
                        <v-spacer></v-spacer>
                        <span
                          style="
                            font-weight: bold;
                            font-size: 25px;
                            line-height: 25px;
                          "
                          >{{ item.des }}</span
                        >
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>
                  </v-autocomplete>

                  <span :style="elemento.stile" v-if="elemento.tipo == 5">{{
                    elemento.testo
                  }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Checkbox conferma lettura (se notifica_tipo = "AVVISO")-->
          <v-row
            class="pt-5 ml-5 mr-5"
            justify="center"
            align="center"
            v-if="notifica.val_int == 1"
          >
            <v-checkbox
              label="Confermo di aver letto"
              v-model="conferma_lettura"
            />
          </v-row>

          <v-row class="pt-0 ml-5 mr-5" justify="center">
            <!-- Pulsanti "Sì/No" se notifica_tipo è "DOMANDA" -->
            <template v-if="notifica.val_int == 2">
              <!-- Pulsante "Sì" -->
              <v-col align="right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="setNotificaVisualizzato('SI')"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span> Sì </span>
                </v-tooltip>
              </v-col>

              <!-- Pulsante "No"-->
              <v-col align="left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="setNotificaVisualizzato('NO')"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span> No </span>
                </v-tooltip>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "PopupNotifica",
  components: { SnackbarQV },
  props: ["notifiche", "originalpath"],
  data() {
    return {
      testo_pulsante: null,
      hasAllegato: false,
      dlgKey: true,
      notifica: {},
      notificaIdx: 0,
      conferma_lettura: false,
      showDialog: true,
      logo_azienda: localStorage.getItem("img_azienda"),
      variabili: [],
      numRows: 1,
    };
  },
  mounted() {
    this.notifica = this.notifiche[this.notificaIdx];
    // Se il tipo di notifica è "PROMEMORIA", non c'è bisogno della conferma lettura.
    if (this.notifica.val_int == 0 || this.notifica.val_int == 3)
      this.conferma_lettura = true;
    if (this.notifica.id_allegato != null || this.notifica.file_b64 != null)
      this.hasAllegato = true;
    if (
      typeof this.notifica.testo_pulsante != "undefined" &&
      this.notifica.testo_pulsante != null &&
      this.notifica.testo_pulsante != ""
    ) {
      this.testo_pulsante = this.notifica.testo_pulsante;
    }
    if (this.notifica.val_int == 3) {
      this.getVariabili();
    }

    // Mi assicuro che non ci sia un'immagine aziendale.
    const timer = 3000;
    let counter = 0;
    const counter_step = 100;

    const that = this;
    let chk_img = setInterval(function () {
      counter += counter_step;
      let stop_chk = false;
      if (
        (localStorage.img_azienda !== null &&
          localStorage.img_azienda !== undefined &&
          localStorage.img_azienda !== "") ||
        counter > timer
      ) {
        stop_chk = true;
        that.logo_azienda = localStorage.img_azienda;
      }

      if (stop_chk) {
        clearInterval(chk_img);
      }
    }, counter_step);
  },
  methods: {
    clickChiudi() {
      this.$router.push(this.originalpath);
      this.$emit("chiudi_popup");
    },
    checkValue(item) {
      if (item.tipo != 0) {
        return;
      }
      if (item.val_min != "") {
        if (parseFloat(item.risposta) < parseFloat(item.val_min)) {
          item.risposta = item.val_min;
        }
      }
      if (item.val_max != "") {
        if (parseFloat(item.risposta) > parseFloat(item.val_max)) {
          item.risposta = item.val_max;
        }
      }
    },
    emitSnackbarMessage(arg) {
      const evento = new CustomEvent("eseguito_form", arg);
      document.getElementById("general_app_bar").dispatchEvent(evento);
    },
    getVariabili() {
      var request = {
        controller: "Notifiche",
        method: "POST",
        richiesta: {
          action: "getvariabili",
          token: localStorage.getItem("user_token"),
          id_notifica: this.notifica.id_notifica,
          execute_query_testi: 1,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.variabili = res.data.result;
        for (var v of this.variabili) {
          v.elementi = null;
          v.risposta = null;
          v.id_notifica_visualizzata = -1;
          if (v.tipo == 4 && v.query_result != null && v.query_result != "") {
            v.elementi = JSON.parse(v.query_result);
          }

          if (v.riga != null && v.riga > this.numRows) {
            this.numRows = v.riga;
          }
        }

        this.variabili.sort((a, b) => (a.ordine < b.ordine ? -1 : 1));
      });
    },
    openLink() {
      window.open(this.notifica.link, "_blank");
    },
    downloadAllegato() {
      if (this.notifica.file_b64 == null) {
        let request = {
          controller: "eallegati",
          method: "POST",
          richiesta: {
            action: "download",
            id_allegato: this.notifica.id_allegato,
            token: localStorage.user_token,
          },
        };
        this.$store.dispatch("api6", request).then((res) => {
          this.tempFile = res;
          var a = document.createElement("a");
          a.setAttribute(
            "download",
            this.notifica.nome_file + this.notifica.estensione
          );
          a.href =
            "data:application/octet-stream;base64," + this.tempFile.data.result;
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
      } else {
        var a = document.createElement("a");
        a.setAttribute("download", this.notifica.file_name);
        a.href =
          "data:application/octet-stream;base64," + this.notifica.file_b64;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
    setNotificaVisualizzato(risposta) {
      var request = {
        controller: "Notifiche",
        method: "PUT",
        richiesta: {
          action: "setvisualizzato",
          id_notifica: this.notifica.id_notifica,
          risposta: risposta,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store
        .dispatch("api", request)
        .then(() => {
          if (this.notificaIdx >= this.notifiche.length - 1) {
            this.$router.push(this.originalpath);
            this.$emit("chiudi_popup");
          } else {
            this.notificaIdx = this.notificaIdx + 1;
            this.notifica = this.notifiche[this.notificaIdx];
            this.conferma_lettura = false;
            this.dlgKey = !this.dlgKey;
          }
        })
        .catch((err) => {
          console.log("Errore:");
          console.log(err);
        });
    },
    confirm(risposta) {
      if (this.notifica.val_int == 3) {
        for (const v of this.variabili) {
          if (v.tipo != 5 && (v.risposta == null || v.risposta == "")) {
            this.$refs.SnackbarQV.print(
              "orange",
              "Valorizzare tutti i campi di input."
            );
            return;
          }
        }

        /* Innesco la funzione di controllo. La funzione fa una chiamata
         * a BE per il controllo dei dati. Se il controllo ha successo,
         * i dati vengono salvati con una successiva funzione automatica
         * di salvataggio. Se il controllo non ha successo, stampa gli
         * avvisi che il BE le dice di stampare. */
        this.eseguiControllo();
      } else {
        this.setNotificaVisualizzato(risposta);
      }
    },
    eseguiControllo() {
      for (var v of this.variabili) {
        v.elementi = null;
      }
      var request = {
        controller: "Notifiche",
        method: "POST",
        richiesta: {
          action: "eseguicontrollo",
          id_notifica: this.notifica.id_notifica,
          variabili: this.variabili.filter((v) => v.tipo != 5),
          token: localStorage.getItem("user_token"),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            /* Preparo il messaggio da stampare nella pagina
             * originale quando il popup viene chiuso. */
            const messaggio = {
              detail: {
                colore: "success",
                testo: "I dati del form sono stati registrati.",
              },
            };

            // Se il BE mi dice che posso salvare, salvo.
            if (res.data.result.length == 0) {
              this.setVariabili(messaggio);
            } else if (res.data.result[0].codice != 2) {
              // Se il BE mi manda un messaggio di warning lo stampo.
              messaggio.detail.colore =
                res.data.result[0].codice == 1 ? "orange" : "success";
              messaggio.detail.testo = res.data.result[0].testo;
              this.setVariabili(messaggio);
            } else {
              // Se il BE manda un messaggio di errore, mi fermo e lo stampo.
              messaggio.detail.colore = "error";
              messaggio.detail.testo = res.data.result[0].testo;
              this.emitSnackbarMessage(messaggio);
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    setVariabili(arg) {
      for (var v of this.variabili) {
        v.elementi = null;
      }
      var request = {
        controller: "Notifiche",
        method: "PUT",
        richiesta: {
          action: "setvariabilirisposte",
          id_notifica: this.notifica.id_notifica,
          variabili: this.variabili.filter((v) => v.tipo != 5),
          token: localStorage.getItem("user_token"),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            /* Se questo è un form, stampo una snackbar
             * sopra tutto il resto del sistema. */
            if (this.notifica.val_int == 3) {
              this.emitSnackbarMessage(arg);
            }

            /* Se non ci sono altre notifiche torno alla rotta
             * di partenza, altrimenti visualizzo la prossima notifica. */
            if (this.notificaIdx >= this.notifiche.length - 1) {
              this.$router.push(this.originalpath);
              this.$emit("chiudi_popup");
            } else {
              this.notificaIdx = this.notificaIdx + 1;
              this.notifica = this.notifiche[this.notificaIdx];
              this.conferma_lettura = false;
              this.dlgKey = !this.dlgKey;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
  },
};
</script>

<style scoped>
#background-video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /* z-index: -1; */
}
</style>
